import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { SIDEBAR_COLLAPSE } from '../../helpers/globalConstants';

export const useSidebarCollapse = create(
  persist(
    (set) => ({
      openSidebar: true,
      toggleSidebar: () =>
        set((state) => ({ openSidebar: !state.openSidebar })),
    }),
    {
      name: SIDEBAR_COLLAPSE,
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
